//import { setTimeout } from "timers";

;var Chapter = function(data, index, _onChangeChapter, _onEnter, _onExit) {

  var onChangeChapter = _onChangeChapter;
  var dispatchOnEnter = _onEnter;
  var dispatchOnExit = _onExit;

  // chapter
  var chapter = $(getChapterHTML());
  chapter.find('[data-index]').on('click', onClickArrows);
  chapter.find('.video.forward, .video.backward').on('ended', onVideoEnded);
  $('#root').append(chapter);

  // info
  var info = Info(chapter);

  // rotateButton
  var rotateButton = RotateButton(chapter);

  // product
  var product = Product(chapter.find('.product'), data.sequence);

  // button navigation
  var button = $(
    '<button class="button" data-index="'+index+'">' +
    '  <img src="'+Preloader.getUrl(data.img)+'"></img>' +
    '  <h2>'+data.title+'</h2>' +
    '</button>'
  );
  button.on('click', onClickNavigationButton);
  $('#navigation').append(button);

  // autoplay loop video
  $('body').on('click', playLoopVideo);
  function playLoopVideo() {
    var videoLoop = chapter.find('.video.loop');
    if (videoLoop.length) {
      videoLoop.get(0).play();
    }
    $('body').off('click', playLoopVideo);
  };

  function getChapterHTML() {
    return (
      '<div class="chapter">' +
      '  <video class="video forward" muted playsinline preload>' +
      '    <source src="'+Preloader.getUrl(data.video.forward)+'" type="video/mp4">' +
      '  </video>' +
      '  <video class="video backward" muted playsinline preload>' +
      '    <source src="'+Preloader.getUrl(data.video.backward)+'" type="video/mp4">' +
      '  </video>' +
      '  <div class="content">'+getContentHTML(data, index)+'</div>' +
      '  <button class="arrow prev start-moment-2" data-index="'+(index - 1)+'"></button>' +
      '  <button class="arrow next start-moment-2" data-index="'+(index + 1)+'"></button>' +
      '</div>'
    );
  }

  function getContentHTML(data, index) {
    if (index === 0) {
      return (
        '<video class="video loop" muted playsinline preload loop>' +
        '  <source src="'+Preloader.getUrl(data.video.loop)+'" type="video/mp4" >' +
        '</video>' +
        '<div class="navigationScreen">' +
        '  <div>' + // fix IE 11, cannot combine display flex with calc https://stackoverflow.com/questions/31323915/internet-explorer-incorrectly-calculates-percentage-height-for-generated-content
        '    <div class="title start-moment-1">Explore the new <span>3Shape <span class="highlight">TRIOS MOVE</span></span></div>' +
        '    <button class="button" data-index="1">' +
        '      <span class="start-moment-1">'+data.title+'</span>' +
        '      <span class="start-moment-2">Play again</span>' +
        '    </button>' +
        '  </div>' +
        '</div>'
      );
    }

    var sequence = data.sequence || {};

    return (
      '<div class="product"></div>' +
      '<div class="rotateButton '+sequence.direction+sequence.type+'"></div>' +
      '<div class="infoWrapper">' +
      ' <div class="infoContainer">' +
      '   <div class="infoContent">' +
      '     <h3 class="infoTitle">'+data.infoTitle+'</h3>' +
      '     <h4 class="infoSubtitle">'+data.infoSubtitle+'</h4>' +
      '     <p class="infoText">'+data.infoText+'</p>' +
      '   </div>' +
      ' </div>' +
      '</div>' +
      (data.infoSizeText 
        ? '<div class="infoSizeWrapper">' +
          ' <div class="infoSizeContainer">' +
          '   <div class="infoContent">' +
          '     <h3 class="infoTitle">'+data.infoTitle+'</h3>' +
          '     <h4 class="infoSubtitle">'+data.infoSubtitle+'</h4>' +
          '     <p class="infoSizeText">'+data.infoSizeText+'</p>' +
          '   </div>' +
          ' </div>' +
          '</div>' +
          '<button class="infoSizeButton"></button>'
        : '' ) +
      '<button class="infoButton"></button>'
    );
  }

  function onClickArrows(e) {
    var index = $(e.currentTarget).attr('data-index');
    onChangeChapter(index, true);
  }

  function onClickNavigationButton(e) {
    var index = $(e.currentTarget).attr('data-index');
    onChangeChapter(index);
  }

  function transitionOut(type) {

    info.close();

    if (product) {
      if (type) {
        product.transitionOut(type, onProductReady);
      } else {
        product.transitionOut(type);
        onProductReady();
      }
    } else {
      chapter.find('.navigationScreen').addClass('transition');
      onProductReady();
    }
  }

  function onProductReady() {
    chapter.find('.rotateButton').removeClass('startSimulation displayNone');
    chapter.find('.rotateButton').removeClass('appear');
    chapter.find('.infoButton').removeClass('appear');
    chapter.find('.infoSizeButton').removeClass('appear');

    setTimeout(function() {
      chapter.removeClass('active');
      chapter.find('.video').removeClass('active');
      chapter.find('.content').removeClass('active');
      dispatchOnExit();
    }, 500)
  }

  function prepareToTransitionIn(type) {
    chapter.addClass('active').css('z-index', '-1');

    chapter.find('.content').addClass('active');

    chapter.find('.product').removeClass('appear');
    chapter.find('.rotateButton').removeClass('appear');
    chapter.find('.infoButton').removeClass('appear');
    chapter.find('.infoSizeButton').removeClass('appear');

    if (product) {
      product.transitionIn(type);
    }

    var videoLoop = chapter.find('.video.loop');
    if (videoLoop.length) {
      // fix IE 11
      if (!isNaN(videoLoop.get(0).duration)) {
        videoLoop.get(0).currentTime = 0;
        videoLoop.get(0).pause();
      }
    }

    var videoSelector = type ? '.video.'+type : '';
    if (videoSelector) {
      chapter.find(videoSelector).get(0).currentTime = 0;
      chapter.find(videoSelector).addClass('active').get(0).load();
    }
  }

  function transitionIn(type) {
    chapter.css('z-index', '0');

    var videoSelector = type ? '.video.'+type : '';
    if (videoSelector) {
      chapter.find(videoSelector).addClass('active').get(0).play();
    } else {
      onVideoEnded();
    }
  }

  function onVideoEnded(e) {
    // visual fix: back to frame 0 to prepare next transtion
    // wait 2 seconds to give time for image render
    if (e && e.currentTarget) {
      setTimeout(function() {
        e.currentTarget.currentTime = 0;
      }, 2000);
    }

    var videoLoop = chapter.find('.video.loop');
    if (videoLoop.length) {
      videoLoop.addClass('active').get(0).play();
    }

    setTimeout(function() {
      chapter.find('.product').addClass('appear');
      chapter.find('.rotateButton').addClass('appear');
      chapter.find('.infoButton').addClass('appear');
      chapter.find('.infoSizeButton').addClass('appear');
      chapter.find('.navigationScreen').removeClass('transition');
      dispatchOnEnter();
    }, 250);
  }

  return {
    transitionOut: transitionOut,
    transitionIn: transitionIn,
    prepareToTransitionIn: prepareToTransitionIn,
  }

};
